import { ImageFormat } from '@bg-shared/enums';

export const IMAGES_PATH = '/iframe/images';

export enum ImageResolution {
    SIZE_320 = 320,
    SIZE_480 = 480,
    SIZE_640 = 640,
    SIZE_800 = 800,
    SIZE_1024 = 1024,
    SIZE_1280 = 1280,
    SIZE_1600 = 1600,
    SIZE_1920 = 1920,
}

export const DEFAULT_BRANDED_PATH = 'default';

type IImageConfigKey =
    | 'GAME_CARDS'
    | 'CURTAIN'
    | 'CURTAIN_SMALL'
    | 'GAMIFICATION_WIZARD'
    | 'GAME_BACKGROUND'
    | 'GIZA_SECTORS'
    | 'SPLASH_SCREEN_TITLE'
    | 'SPLASH_SCREEN_TITLE_SMALL'
    | 'SPLASH_SCREEN_BACKGROUND_PORTRAIT'
    | 'SPLASH_SCREEN_BACKGROUND_LANDSCAPE'
    | 'SPLASH_SCREEN_RECT';

export interface IImageConfigValue {
    path: string;
    sizes: number[];
    formats: ImageFormat[];
    media?(sizes: ImageResolution[], index: number): string;
}

type IImageConfig = Record<IImageConfigKey, IImageConfigValue>;

export const IMAGE_CONFIG: IImageConfig = {
    GAME_CARDS: {
        path: 'game-cards',
        sizes: [ImageResolution.SIZE_320],
        formats: [ImageFormat.AVIF, ImageFormat.WEBP, ImageFormat.JPG],
    },
    CURTAIN: {
        path: 'curtains/large',
        sizes: [
            ImageResolution.SIZE_640,
            ImageResolution.SIZE_800,
            ImageResolution.SIZE_1024,
            ImageResolution.SIZE_1280,
            ImageResolution.SIZE_1600,
            ImageResolution.SIZE_1920,
        ],
        formats: [ImageFormat.AVIF, ImageFormat.WEBP, ImageFormat.JPG],
        media: (sizes, index) =>
            sizes[index] === ImageResolution.SIZE_1920
                ? `(min-width: ${Math.ceil(ImageResolution.SIZE_1600 / 2)}px)`
                : `(max-width: ${Math.ceil(sizes[index] / 2) - 1}px)`,
    },
    CURTAIN_SMALL: {
        path: 'curtains/small',
        sizes: [ImageResolution.SIZE_480, ImageResolution.SIZE_640, ImageResolution.SIZE_800],
        formats: [ImageFormat.AVIF, ImageFormat.WEBP, ImageFormat.JPG],
    },
    GAMIFICATION_WIZARD: {
        path: 'gamification/wizard',
        sizes: [ImageResolution.SIZE_320, ImageResolution.SIZE_480, ImageResolution.SIZE_640],
        formats: [ImageFormat.AVIF, ImageFormat.WEBP, ImageFormat.JPG],
    },
    GAME_BACKGROUND: {
        path: 'game-backgrounds',
        sizes: [
            ImageResolution.SIZE_640,
            ImageResolution.SIZE_800,
            ImageResolution.SIZE_1024,
            ImageResolution.SIZE_1280,
            ImageResolution.SIZE_1600,
            ImageResolution.SIZE_1920,
        ],
        formats: [ImageFormat.AVIF, ImageFormat.WEBP, ImageFormat.JPG],
        media: (sizes, index) =>
            sizes[index] === ImageResolution.SIZE_1920
                ? `(min-width: ${Math.ceil(ImageResolution.SIZE_1600 / 2)}px)`
                : `(max-width: ${Math.ceil(sizes[index] / 2) - 1}px)`,
    },
    GIZA_SECTORS: {
        path: 'giza-sectors',
        sizes: [ImageResolution.SIZE_320],
        formats: [ImageFormat.AVIF, ImageFormat.WEBP, ImageFormat.PNG],
    },
    SPLASH_SCREEN_TITLE: {
        path: 'lenny/splashscreen',
        sizes: [ImageResolution.SIZE_640],
        formats: [ImageFormat.AVIF, ImageFormat.WEBP, ImageFormat.PNG],
    },
    SPLASH_SCREEN_TITLE_SMALL: {
        path: 'lenny/splashscreen',
        sizes: [ImageResolution.SIZE_320, ImageResolution.SIZE_480, ImageResolution.SIZE_640],
        formats: [ImageFormat.AVIF, ImageFormat.WEBP, ImageFormat.PNG],
    },
    SPLASH_SCREEN_BACKGROUND_PORTRAIT: {
        path: 'lenny/splashscreen',
        sizes: [ImageResolution.SIZE_320, ImageResolution.SIZE_480, ImageResolution.SIZE_640],
        formats: [ImageFormat.AVIF, ImageFormat.WEBP, ImageFormat.JPG],
    },
    SPLASH_SCREEN_BACKGROUND_LANDSCAPE: {
        path: 'lenny/splashscreen',
        sizes: [
            ImageResolution.SIZE_640,
            ImageResolution.SIZE_800,
            ImageResolution.SIZE_1024,
            ImageResolution.SIZE_1280,
            ImageResolution.SIZE_1600,
            ImageResolution.SIZE_1920,
        ],
        formats: [ImageFormat.AVIF, ImageFormat.WEBP, ImageFormat.JPG],
    },
    SPLASH_SCREEN_RECT: {
        path: 'lenny/splashscreen',
        sizes: [
            ImageResolution.SIZE_320,
            ImageResolution.SIZE_480,
            ImageResolution.SIZE_640,
            ImageResolution.SIZE_800,
            ImageResolution.SIZE_1024,
        ],
        formats: [ImageFormat.AVIF, ImageFormat.WEBP, ImageFormat.PNG],
    },
};
